"use strict";
/** state: Final **/
/** family: Slideout **/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var Backdrop_1 = require("../Backdrop");
var SlideoutBody_1 = require("../SlideoutBody");
var SlideoutFooter_1 = require("../SlideoutFooter");
var SlideoutHeader_1 = require("../SlideoutHeader");
var CLASS_NAME = 'i-slideout';
var SlideoutSize;
(function (SlideoutSize) {
    SlideoutSize["Dynamic"] = "dynamic";
    SlideoutSize["Large"] = "lg";
    SlideoutSize["Medium"] = "md";
    SlideoutSize["Small"] = "sm";
})(SlideoutSize = exports.SlideoutSize || (exports.SlideoutSize = {}));
var SlideoutPosition;
(function (SlideoutPosition) {
    SlideoutPosition["Left"] = "left";
    SlideoutPosition["Right"] = "right";
})(SlideoutPosition = exports.SlideoutPosition || (exports.SlideoutPosition = {}));
/**
 * Slideouts are used to show additional information or to allow users to perform secondary tasks without leaving their normal workflow.
 *
 * Slideouts can be used for simple forms, or where the user needs to still refer to the contents of the page.
 *
 * Also see {{Modal}}.
 */
var Slideout = /** @class */ (function (_super) {
    __extends(Slideout, _super);
    function Slideout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Slideout.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, backdrop = _b.backdrop, children = _b.children, className = _b.className, position = _b.position, size = _b.size, show = _b.show, restProps = __rest(_b, ["backdrop", "children", "className", "position", "size", "show"]);
        return (React.createElement(React.Fragment, null,
            backdrop && (React.createElement(Backdrop_1.Backdrop, __assign({ active: show, elements: [this.ref] }, backdrop))),
            React.createElement("div", __assign({ "aria-hidden": !show, className: classNames(CLASS_NAME, (_a = {},
                    _a[CLASS_NAME + "--" + size] = size != null,
                    _a[CLASS_NAME + "--" + position] = position != null,
                    _a.shown = show,
                    _a), className), ref: function (ref) { return (_this.ref = ref); }, role: "dialog" }, restProps), children)));
    };
    Slideout.Header = SlideoutHeader_1.SlideoutHeader;
    Slideout.Body = SlideoutBody_1.SlideoutBody;
    Slideout.Footer = SlideoutFooter_1.SlideoutFooter;
    Slideout.Position = SlideoutPosition;
    Slideout.Size = SlideoutSize;
    Slideout.defaultProps = {
        position: Slideout.Position.Right,
        size: Slideout.Size.Small,
    };
    return Slideout;
}(React.Component));
exports.Slideout = Slideout;
Slideout.defaultProps = {
    position: Slideout.Position.Right,
    size: Slideout.Size.Small,
};
//# sourceMappingURL=Slideout.js.map